import { STATIC_URL } from "../config";

const formatPaymentButton = (link) => {
  const buttonText = `${link.days} дней - ${link.price} руб.`;
  return `[URL="${link.url}"][B][COLOR=#FFD700]${buttonText}[/COLOR][/B] (нажмите здесь для покупки)[/URL]`;
};

export const formatProductForXenForo = (product) => {
  const features = product.features
    .map((feature) => {
      if (feature.description.includes("\n")) {
        return `[B]${feature.name}:[/B]\n${feature.description}`;
      }
      return `[B]${feature.name}:[/B] ${feature.description}`;
    })
    .join("\n");

  // Обработка системных требований с сохранением переносов строк
  const requirements = Array.isArray(product.systemRequirements)
    ? product.systemRequirements.join("\n") // Заменяем запятые на переносы строк
    : product.systemRequirements || "";

  const paymentButtons = product.paymentLinks
    .map((link) => formatPaymentButton(link))
    .join("\n");

  const statusColor =
    {
      Undetected: "green",
      Detected: "red",
      "On Update": "orange",
      "Use at own risk": "orange",
    }[product.status] || "orange";

  return `[CENTER][SIZE=6][B][COLOR=#FFA500]${product.name}[/COLOR][/B][/SIZE]


${product.images[0] ? `[IMG]${STATIC_URL}/${product.images[0]}[/IMG]\n` : ""}

[SPOILER="Основные функции"]
${features}
[/SPOILER]

[SIZE=5][B][COLOR=#FFA500]Системные требования[/COLOR][/B][/SIZE]
${requirements.replace(/\\n/g, "\n")}  

[SIZE=5][B][COLOR=#FFA500]Цены и покупка[/COLOR][/B][/SIZE]
${paymentButtons}
[SIZE=1][COLOR=#FFD700]Выберите подходящий тариф и нажмите кнопку покупки[/COLOR][/SIZE]

[SPOILER="Как Купить?"]
[B]Выбор продукта[/B]
Найдите нужный чит в нашем каталоге
[B]Оплата подписки[/B]
Выберите срок и удобный способ платежа
[B]Скачивание[/B]
Получите файл и инструкцию после оплаты
[B]Запуск[/B]
Активируйте согласно инструкции чит и получайте преимущества в игре
[/SPOILER]


[SIZE=6][URL="https://twizzycheats.ru"][B]Официальный сайт[/B][/URL] | [URL="https://t.me/TwizzyCheatsSupport"][B]Поддержка в Telegram[/B][/URL] | [URL="https://t.me/twizzycheats"][B]Новости и обновления[/B][/URL][/SIZE]
[/CENTER]`;
};
